import { useState } from "react";
import { Bell } from "react-feather";
import { Card, CardBody, Col, Toast, ToastBody } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { StackingToastsTitle } from "../../../../Constants/Constants";
import { StackingToastsSubTitle } from "../../../../Data/BonusUi/Toasts";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import StackingToastsLists from "./StackingToastsLists";

const StackingToasts = () => {
  const [open, setOpen] = useState(true);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={StackingToastsTitle} span={StackingToastsSubTitle} />
        <CardBody className="toast-rtl">
          <div className="toast-container position-static">
            <Toast isOpen={open}>
              <div className="toast-header">
                <Bell className="toast-icons toast-primary" />
                <strong className="me-auto">{"Moscow theme"}</strong>
                <small className="txt-danger">{"just now"}</small>
                <Btn close className="p-0" onClick={() => setOpen(false)}></Btn>
              </div>
              <ToastBody className="toast-dark">{"Hello, I'm a web-designer."}</ToastBody>
            </Toast>
            <StackingToastsLists />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default StackingToasts;
